import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BaseMenuItemInventoryComponent} from '../base-menu-item-inventory.component';
import {MenuCategoryItem} from '../../_models/menu-category-item';
import {MenuItemInventoryService} from '../../_services/menu-item-inventory.service';
import {OrganizationTerminalService} from '../../_services/organization-terminal.service';
import {ModalController} from '@ionic/angular';
import {MenuItem} from '../../_models/menu-item';
import {MenuItemPrice} from '../../_models/menu-item-price';

@Component({
    selector: 'bb-mobile-menu-all-prices',
    templateUrl: './mobile-menu-all-prices.component.html',
    styleUrls: ['./mobile-menu-all-prices.component.scss'],
})
export class MobileMenuAllPricesComponent extends BaseMenuItemInventoryComponent implements OnInit {
    @Input() item: MenuCategoryItem;
    @Input() showInventory = false;
    @Output() priceSelected = new EventEmitter();

    constructor(
        modalController: ModalController,
        menuItemInventoryService: MenuItemInventoryService,
        organizationTerminalService: OrganizationTerminalService
    ) {
        super(modalController, menuItemInventoryService, organizationTerminalService);
    }

    ngOnInit() {
        this.menuItem = this.item.menuItem;
        super.ngOnInit();
    }

    addWithPrice(menuItem: MenuItem, price: MenuItemPrice, forceModal = false) {
        this.priceSelected.emit({menuItem, price, forceModal});
    }
}
